export default __webpack_public_path__ + "static/media/appointmentIcon.1f01a679.svg";